<span *ngIf="tooltip" class="tooltip-control" nzTooltipPlacement="top" nzTooltipTitle="Nhấn vào đây để xem chi tiết" nz-button nz-tooltip
    (click)="triggerModal(formFieldConfig)">&nbsp;<i nz-icon nzType="question-circle"></i>
</span>